import React from "react";
import { Table, Card } from "antd";
import { commonSorterForTable } from "../../../../utils";
import "./styles.scss";

const TableComponent = ({
  columns = [],
  dataSource = [],
  loading = false,
  pagination = {
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    showTotal: (total) => `Total ${total} items`,
  },
  onChange,
  className = "",
  rowKey = "id",
  scroll = { x: "max-content" },
  size = "middle",
  bordered = true,
  style = {},
  title,
  extra,
  cardProps = {},
}) => {
  // Process columns to add automatic sorting functionality
  const processedColumns = columns.map(column => {
    const updatedColumn = { ...column };

    if (updatedColumn.sorter === true && updatedColumn.dataIndex) {
      updatedColumn.sorter = (a, b) => commonSorterForTable(a, b, updatedColumn.dataIndex);
    }

    if (typeof updatedColumn.render !== "function") {
      updatedColumn.render = (value) => {
        if (value === null || value === undefined || (typeof value === "string" && value.trim() === "")) {
          return "---";
        }
        return value;
      };
    }

    return updatedColumn;
  });

  return (
    <Card
      title={title}
      extra={extra}
      className={`master-table-card ${className}`}
      {...cardProps}
    >
      <Table
        columns={processedColumns}
        dataSource={Array.isArray(dataSource) ? dataSource : []}
        loading={loading}
        pagination={pagination}
        onChange={onChange}
        className="master-table"
        rowKey={rowKey}
        scroll={scroll}
        size={size}
        bordered={bordered}
        style={style}
      />
    </Card>
  );
};

export default TableComponent; 
